import React from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./FormSection.module.css";

interface FormSectionProps {
  /** Section heading displayed above the fields */
  title: React.ReactNode;
  /** How many columns the inner grid should have (defaults to 2 to match FormBody) */
  columnCount?: number;
  className?: string;
}

/**
 * Utility wrapper that groups a header with its related form fields.
 * The whole section spans all columns of the outer <FormBody> grid,
 * and internally renders another grid so that we can fine-tune the
 * spacing between the header and the first row of fields without
 * affecting global `gap` set on the outer grid.
 */
const FormSection: React.FC<React.PropsWithChildren<FormSectionProps>> = ({
  title,
  columnCount = 2,
  children,
  className,
}) => {
  return (
    <div className={toClassName(styles.container, className)}>
      <div className={styles.title}>{title}</div>
      <div
        className={styles.grid}
        style={{ gridTemplateColumns: `repeat(${columnCount}, 1fr)` }}
      >
        {children}
      </div>
    </div>
  );
};

export default FormSection;
